import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

export const getAllRadiologyReport = createAsyncThunk(
  "radiologyReport/getAllRadiologyReport",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/radiologyReport/getAllRadiologyReport",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token,
          },
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const getOutSourceToRadiologyReport = createAsyncThunk(
  "radiologyReport/getOutSourceToRadiologyReport",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/radiologyReport/getOutSourceToRadiologyReport",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token,
          },
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const getOutSourceFromRadiologyReport = createAsyncThunk(
  "radiologyReport/getOutSourceFromRadiologyReport",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/radiologyReport/getOutSourceFromRadiologyReport",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token,
          },
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const updateRadiologyReport = createAsyncThunk(
  "radiologyReport/updateRadiologyReport",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        "/radiologyReport/updateRadiologyReport",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token,
          },
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const getPatientRadiologyReports = createAsyncThunk(
  "radiologyReport/getPatientRadiologyReports",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/radiologyReport/getPatientRadiologyReports",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token,
          },
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

const initialState = {
  radiologyReports: [],
  patientRadiologyReports: [],
  loading: false,
  patientLoading: false,
  patientRadiologyReportsForPatientId: null,
  patientRadiologyReportsRequestId: null,
  searchMessage: null,
  updateRadiologyReportSuccessMessage: null,
  updateRadiologyReportErrorMessage: null,
  currentPage: 1,
  totalPages: null,
  hasMore: true,
  totalCount: 0,
};

const radiologyReportSlice = createSlice({
  name: "radiologyReport",
  initialState,
  reducers: {
    resetUpdateRadiologyReportMessage: (state) => {
      state.updateRadiologyReportSuccessMessage = null;
      state.updateRadiologyReportErrorMessage = null;
    },
    resetPatientRadiologyReportsState: (state) => {
      state.patientRadiologyReports = [];
      state.patientLoading = false;
      state.patientRadiologyReportsForPatientId = null;
      state.patientRadiologyReportsRequestId = null;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(getAllRadiologyReport.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllRadiologyReport.fulfilled, (state, action) => {
        state.loading = false;
        if (!action.payload.success) {
          state.radiologyReports = [];
          state.totalCount = 0;
          state.totalPages = 1;
          state.currentPage = 1;
          state.hasMore = false;
          state.searchMessage =
            action.payload.result?.message || "No Radiology Report found";
          return;
        }
        const result = action.payload.result;
        state.radiologyReports = result.list || [];
        state.currentPage = Number(result.currentPage) || 1;
        state.totalPages = Number(result.totalPages) || 1;
        state.totalCount = Number(result.totalRecords) || 0;
        state.hasMore = result.hasMore ?? false;
        state.searchMessage = null;
      })
      .addCase(getAllRadiologyReport.rejected, (state) => {
        state.loading = false;
      })
      .addCase(getOutSourceToRadiologyReport.pending, (state) => {
        state.loading = true;
      })
      .addCase(getOutSourceToRadiologyReport.fulfilled, (state, action) => {
        state.loading = false;
        if (!action.payload.success) {
          state.radiologyReports = [];
          state.totalCount = 0;
          state.totalPages = 1;
          state.currentPage = 1;
          state.hasMore = false;
          state.searchMessage =
            action.payload.result?.message || "No Data found";
          return;
        }
        const result = action.payload.result;
        state.radiologyReports = result.list || [];
        state.currentPage = Number(result.currentPage) || 1;
        state.totalPages = Number(result.totalPages) || 1;
        state.totalCount = Number(result.totalRecords) || 0;
        state.hasMore = result.hasMore ?? false;
        state.searchMessage = null;
      })
      .addCase(getOutSourceToRadiologyReport.rejected, (state) => {
        state.loading = false;
      })
      .addCase(getOutSourceFromRadiologyReport.pending, (state) => {
        state.loading = true;
      })
      .addCase(getOutSourceFromRadiologyReport.fulfilled, (state, action) => {
        state.loading = false;
        if (!action.payload.success) {
          state.radiologyReports = [];
          state.totalCount = 0;
          state.totalPages = 1;
          state.currentPage = 1;
          state.hasMore = false;
          state.searchMessage =
            action.payload.result?.message || "No Data found";
          return;
        }
        const result = action.payload.result;
        state.radiologyReports = result.list || [];
        state.currentPage = Number(result.currentPage) || 1;
        state.totalPages = Number(result.totalPages) || 1;
        state.totalCount = Number(result.totalRecords) || 0;
        state.hasMore = result.hasMore ?? false;
        state.searchMessage = null;
      })
      .addCase(getOutSourceFromRadiologyReport.rejected, (state) => {
        state.loading = false;
      })

      .addCase(updateRadiologyReport.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateRadiologyReport.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.updateRadiologyReportErrorMessage =
            action.payload.result.message;
        } else {
          state.updateRadiologyReportSuccessMessage =
            action.payload.result.message;
        }
      })
      .addCase(updateRadiologyReport.rejected, (state) => {
        state.loading = false;
      })
      .addCase(getPatientRadiologyReports.pending, (state, action) => {
        state.patientLoading = true;
        state.patientRadiologyReports = [];
        state.patientRadiologyReportsForPatientId = String(
          action.meta.arg?.patientId || "",
        );
        state.patientRadiologyReportsRequestId = action.meta.requestId;
      })
      .addCase(getPatientRadiologyReports.fulfilled, (state, action) => {
        if (state.patientRadiologyReportsRequestId !== action.meta.requestId) return;
        state.patientLoading = false;
        if (!action.payload?.success) {
          state.patientRadiologyReports = [];
          return;
        }
        const requestedPatientId = String(action.meta.arg?.patientId || "");
        const list = action.payload?.result?.list || [];
        state.patientRadiologyReports = list.filter((item) => {
          const rowPatientId = String(item?.patientId || "");
          return !rowPatientId || rowPatientId === requestedPatientId;
        });
      })
      .addCase(getPatientRadiologyReports.rejected, (state, action) => {
        if (state.patientRadiologyReportsRequestId !== action.meta.requestId) return;
        state.patientLoading = false;
        state.patientRadiologyReports = [];
      });
  },
});

export const {
  resetUpdateRadiologyReportMessage,
  resetPatientRadiologyReportsState,
} =
  radiologyReportSlice.actions;
export default radiologyReportSlice.reducer;
